import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';
import { isValidUrl } from '@bingads-webui/url-util';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import { ImageExperienceImage } from '@bingads-webui-campaign-react/image-experience';
import { ImageModelPropTypes } from '@bingads-webui-campaign/image-experience-proptypes';
import { BusinessNameWithAds } from './business-name-with-ads';

export class AdPlacementCardPreview extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.multiLineTextRefs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];
  }

  componentDidUpdate() {
    this.multiLineTextRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.processText();
      }
    });
  }

  render() {
    const {
      hideLabel,
      multipleLineLongHeadline,
      showImage,
      multipleDescription,
      dismissText,
      showHotspots,
      hotspots,
      isMultimediaAd,
      previewContentClassName,
      isMultiMediaAdsPhase2Enabled,
      previewTexts,
      logo,
      showLogo,
    } = this.props;
    const imageContainerClassName =
      this.props.showGradient ?
        'gradient image-container' :
        'image-container';
    const srcForCroppedImageView = this.props.isAdCreatorEnabled
      ? this.props.image.FinalSrc
      : this.props.image.Src;

    const showMultipleDescription = multipleDescription || (isMultimediaAd && isMultiMediaAdsPhase2Enabled);

    return (
      <a
        className={classnames(previewContentClassName, 'responsive-ad-preview-content')}
        target="_blank"
        rel="noopener noreferrer"
        href={previewTexts.url}
      >
        <div className={imageContainerClassName}>
          {
              this.props.showAdsLabel &&
              isMultimediaAd && isMultiMediaAdsPhase2Enabled &&
              <div className="ads-label">
                {this.props.i18n.getString('Entity_Ads')}
              </div>
            }
          {
              isMultimediaAd && isMultiMediaAdsPhase2Enabled &&
              <div className="gradient" />
            }
          {
            showImage &&
            <CroppedImageView
              resizeImageHeight={this.props.additionalSetting.imagePreviewHeight}
              src={srcForCroppedImageView}
              originalWidth={this.props.image.Width}
              originalHeight={this.props.image.Height}
              SourceX={this.props.image.CropSettings.SourceX}
              SourceY={this.props.image.CropSettings.SourceY}
              SourceWidth={this.props.image.CropSettings.SourceWidth}
              SourceHeight={this.props.image.CropSettings.SourceHeight}
              aspectRatio={this.props.additionalSetting.aspectRatio}
            />
          }
        </div>
        {
          previewContentClassName === 'boost-discover-card' &&
          <div className="hardcode-discover" >{this.props.i18n.getString(_TL_('Discover'))}</div>
        }
        {
          previewContentClassName === 'boost-windows' &&
          <div className="hardcode-time" >
            <div className="welcome" >{this.props.i18n.getString(_TL_('Welcome back. Dismiss the lock screen to sign back into Windows.'))}</div>
            <div className="time" >{this.props.i18n.getString(_TL_('10:36'))}</div>
            <div className="date" >{this.props.i18n.getString(_TL_('Tuesday, October 18'))}</div>
          </div>
        }
        {showLogo && logo &&
          <div className="logo-container">
            <CroppedImageView
              resizeImageHeight={this.props.additionalSetting.logoHeight || 24}
              src={logo.Src}
              originalWidth={logo.Width}
              originalHeight={logo.Height}
              SourceX={logo.CropSettings.SourceX}
              SourceY={logo.CropSettings.SourceY}
              SourceWidth={logo.CropSettings.SourceWidth}
              SourceHeight={logo.CropSettings.SourceHeight}
              aspectRatio={1}
            />
          </div>
        }

        {
          showHotspots &&
          hotspots.map((hotspot, index) => (
            // eslint-disable-next-line
            <div className={`hotspot${index}`} key={`${hotspot.title}${index}`}>
              <div className="hotspot-title" >{hotspot.title}</div>
              <div className="hotspot-action" >{hotspot.actionText}</div>
            </div>
          ))
        }

        <div className="text-container">
          {
              this.props.showShortHeadline &&
              (
                isMultimediaAd ? (
                  isMultiMediaAdsPhase2Enabled &&
                  <div className="short-headline">
                    {previewTexts.shortHeadline}
                  </div>
                ) :
                  <MultiLineEllipsisText
                    ref={this.multiLineTextRefs[0]}
                    className="short-headline"
                    text={previewTexts.shortHeadline}
                  />
              )
            }
          {
              this.props.showLongHeadline &&
              (
                multipleLineLongHeadline ?
                  <div className="long-headline">
                    {previewTexts.longHeadline}
                  </div> :
                  <MultiLineEllipsisText
                    ref={this.multiLineTextRefs[1]}
                    className="long-headline"
                    text={previewTexts.longHeadline}
                  />
              )
            }
          {
              this.props.showUrl &&
              (
                isMultimediaAd ? (
                  isMultiMediaAdsPhase2Enabled &&
                  <div className="final-url">
                    {isValidUrl(previewTexts.url) ?
                      new URL(previewTexts.url).origin : previewTexts.url}
                  </div>
                ) :
                  <MultiLineEllipsisText
                    ref={this.multiLineTextRefs[1]}
                    className="final-url"
                    text={previewTexts.url}
                  />
              )
            }
          {
              this.props.showDescription &&
              (
                showMultipleDescription ?
                  <div className="description">
                    {previewTexts.description}
                  </div>
                 :
                  <MultiLineEllipsisText
                    ref={this.multiLineTextRefs[2]}
                    className="description"
                    text={previewTexts.description}
                  />
              )
            }
          {
              this.props.showBusinessName &&
              <BusinessNameWithAds
                hideLabel={hideLabel}
                i18n={this.props.i18n}
                businessName={previewTexts.businessName}
                showAdsIcon={this.props.showAdsIcon}
              />
            }
          {
              this.props.showAction &&
              previewTexts.callToAction &&
              <button className="action-button">
                {previewTexts.callToAction.replace(/([A-Z])/g, ' $1')}
              </button>
            }
          {
              this.props.showAction &&
              previewTexts.callToAction &&
              dismissText &&
              <button className="dismiss-button">
                {dismissText}
              </button>
            }
        </div>
      </a>
    );
  }
}

AdPlacementCardPreview.propTypes = {
  image: ImageModelPropTypes.isRequired,
  previewTexts: PropTypes.shape({
    shortHeadline: PropTypes.string,
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
    url: PropTypes.string,
    callToAction: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showShortHeadline: PropTypes.bool,
  showLongHeadline: PropTypes.bool,
  showDescription: PropTypes.bool,
  multipleLineLongHeadline: PropTypes.bool,
  hotspots: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    desc: PropTypes.string,
    actionText: PropTypes.string,
    uri: PropTypes.string,
  })),
  multipleDescription: PropTypes.bool,
  showGradient: PropTypes.bool,
  dismissText: PropTypes.string,
  previewContentClassName: PropTypes.string.isRequired,
  additionalSetting: PropTypes.shape({
    imagePreviewHeight: PropTypes.number.isRequired,
    aspectRatio: PropTypes.number.isRequired,
    logoHeight: PropTypes.number,
  }).isRequired,
  logo: PropTypes.instanceOf(ImageExperienceImage),
  showBusinessName: PropTypes.bool,
  showUrl: PropTypes.bool,
  showAction: PropTypes.bool,
  showAdsLabel: PropTypes.bool,
  showHotspots: PropTypes.bool,
  showLogo: PropTypes.bool,
  showImage: PropTypes.bool,
  hideLabel: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  isMultiMediaAdsPhase2Enabled: PropTypes.bool,
  isAdCreatorEnabled: PropTypes.bool,
};

AdPlacementCardPreview.defaultProps = {
  showShortHeadline: false,
  showLongHeadline: false,
  showDescription: false,
  dismissText: null,
  showGradient: false,
  showHotspots: false,
  showBusinessName: true,
  hotspots: [],
  multipleLineLongHeadline: false,
  logo: null,
  showUrl: false,
  multipleDescription: false,
  showAction: false,
  hideLabel: false,
  showLogo: false,
  showImage: true,
  showAdsLabel: false,
  isMultimediaAd: false,
  isMultiMediaAdsPhase2Enabled: false,
  isAdCreatorEnabled: false,
};
